import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { useCallStore } from "~/stores/useCallStore";

const outgoingSearchSchema = z.object({
  user_id: z.string(),
  user_name: z.string().catch(""),
  user_avatar: z.string().optional(),
  user_age: z.coerce.number().optional(),
});

export const Route = createFileRoute("/_authenticated/video")({
  validateSearch: outgoingSearchSchema,
  beforeLoad: ({ search }) => {
    const { phase } = useCallStore.getState();

    // replace: true で /video 自体を履歴に残さない。
    // 残すと発信画面を閉じて history.back() した際に /video へ戻り、
    // この beforeLoad が再度発信画面へ redirect して勝手に再発信されてしまう。
    if (phase.type !== "idle") {
      throw redirect({ to: "/", replace: true });
    }

    throw redirect({
      to: "/call/video/outgoing",
      replace: true,
      search: {
        partner_id: search.user_id,
        partner_name: search.user_name,
        partner_avatar: search.user_avatar,
        partner_age: search.user_age,
      },
    });
  },
});
